;(function () {
	const initProductAccordion = () => {
		const aboutToggleItems = $('.about__accordion-toggle')

		aboutToggleItems.each(function () {
			const currentToggle = $(this)
			const siblingToggles = currentToggle.siblings(
				'.about__accordion-description'
			)

			currentToggle.click(function () {
				if (!currentToggle.hasClass('active')) {
					aboutToggleItems.each(function () {
						const siblingToggle = $(this)
						siblingToggle.removeClass('active')
						siblingToggle
							.siblings('.about__accordion-description')
							.stop()
							.slideUp(300)
					})

					currentToggle.addClass('active')

					siblingToggles.stop().slideDown(300)
				} else {
					currentToggle.removeClass('active')
					siblingToggles.stop().slideUp(300)
				}
			})
		})
	}

	const initZoomImage = () => {
		const imagesWrapper = document.querySelector(
			'.product-media-modal__content'
		)
		const images = imagesWrapper?.querySelectorAll('.js-image-zoom') || []

		images.forEach((el) => {
			el.addEventListener('click', (e) => {
				imagesWrapper.classList.toggle('zoom')
			})
		})
	}

	const formatFreeShippingAmount = (value) => {
		const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/
		const formatString = theme.moneyFormat

		return formatString.replace(placeholderRegex, value)
	}

	const setTotalFreeShipping = () => {
		if (document.querySelector('.js-free-shipping')) {
			const freeShippingTotal = document.querySelector('.free-shipping-total')
			if (freeShippingTotal) {
				const minSpend = Number(freeShippingTotal.dataset.minSpend)
				if (minSpend && minSpend > 0) {
					freeShippingTotal.innerText = `${formatFreeShippingAmount(
						Math.round(minSpend * (Shopify.currency.rate || 1))
					)}`
				}
			}
		}
	}
	function changeIconsViewBox() {
		const textWithIcon = document.querySelectorAll('.text_with_icon')
		textWithIcon.forEach((item) => {
			const icons = item.querySelectorAll('.icon-pack')
			icons.forEach((icon) => {
				icon.setAttribute('viewBox', '0 0 20 20')
			})
		})
	}

	//document.addEventListener('scroll', () => {
	//	const navigation = document.querySelector('.product__media_navigation')
	//	if (navigation) {
	//		const footer = document.querySelector('.footer')
	//		const navigationHeight = navigation.offsetHeight
	//		const screen = window.scrollY
	//		const overview = document.querySelector('#overview').scrollTop
	//		const overviewBottom =
	//			document.querySelector('#overview').clientHeight + overview
	//		if (screen >= overview && screen <= overviewBottom) {
	//			document.querySelector('#overview-link').classList.add('active')
	//		} else {
	//			document.querySelector('#overview-link').classList.remove('active')
	//		}
	//		if (window.innerHeight + screen - navigationHeight > footer.offsetTop) {
	//			navigation.style.opacity = '0'
	//			navigation.style.visibility = 'hidden'
	//		} else {
	//			navigation.style.opacity = '1'
	//			navigation.style.visibility = 'visible'
	//		}
	//	}
	//})

	const navigationSections = [
		{
			sectionSelector: '#overview',
			linkSelector: '#overview-link',
		},
		{
			sectionSelector: '#product-specifications',
			linkSelector: '#specifications-link',
		},
	]

	function navigationInit(sections) {
		const navigation = document.querySelector('.product__media_navigation')
		if (navigation) {
			navigation.style.transform = 'translateX(-50%) translateY(calc(100% + 16px))'
		}
		document.addEventListener('scroll', () => {
			if (navigation) {
				navigation.classList.add('show-navigation')
			}
			if (navigation) {
				const footer = document.querySelector('.footer')
				const navigationHeight = navigation.offsetHeight
				const secondSection = document.querySelectorAll('#MainContent .shopify-section')[1]
				const screen = window.scrollY
				sections.forEach((section, i) => {
					if (section) {
						const em = document.querySelector(`${section.sectionSelector}`)
						if (em) {
							const rect = em.getBoundingClientRect()	
							if (rect.top <= 1 && rect.top > rect.height * -1) {
								document
									.querySelector(`${section.linkSelector}`)
									.classList.add('active')
							} else {
								document
									.querySelector(`${section.linkSelector}`)
									.classList.remove('active')
							}
							document.querySelector(`${section.linkSelector}`).addEventListener('click', () => {
								em.scrollIntoView({ behavior: 'smooth' });
							})
						} else {
							document.querySelector(`${section.linkSelector}`).style.display = 'none';
						}
					}
				})
				
				const rect = secondSection.getBoundingClientRect();
				const isSecondSectionScrolled = rect.top < 0;
				const isNearFooter = window.innerHeight + screen - navigationHeight > footer.offsetTop;

				navigation.style.transform = isSecondSectionScrolled && !isNearFooter
				? 'translateX(-50%) translateY(0)'
				: 'translateX(-50%) translateY(calc(100% + 16px))';
			}
		})
	}

	document.addEventListener('shopify:section:load', function () {
		initProductAccordion()
		initZoomImage()
		setTotalFreeShipping()
		changeIconsViewBox()
		navigationInit(navigationSections)
	})

	navigationInit(navigationSections)
	initProductAccordion()
	initZoomImage()
	setTotalFreeShipping()
	changeIconsViewBox()
})()


function checkForKSChartContainer() {
	let count = 0;
	const interval = setInterval(() => {
	  const ksChartContainer = document.querySelector('.ks-chart-container');
	  if (ksChartContainer) {
		document.querySelector('.size-chart').classList.add('active');
		clearInterval(interval);
	  }
	  count++;
	  if (count >= 20) {
		console.log('ks-chart-container not found after 10 seconds.');
		clearInterval(interval);
	  }
	}, 500);
  }
  
  document.addEventListener('DOMContentLoaded', checkForKSChartContainer);


document.addEventListener('DOMContentLoaded', function () {
	checkProductMediaVideo();
	sezzleCheck();

	if( document.querySelector('square-placement') ){
		document.querySelector('square-placement').closest('.shopify-app-block').classList.add('hidden');
		document.querySelector('.payment-installment-wrapper').append(document.querySelector('square-placement'));		
	}	
});

function sezzleCheck(){	
	const sezzelParent = document.querySelector('.shopify-app-block div[id*=sezzle-widget]') ? 
		document.querySelector('.shopify-app-block div[id*=sezzle-widget]').closest('.shopify-app-block'): null;
	sezzelParent?.classList.add('hidden');
	if( document.querySelector('.shopify-app-block div[id*=sezzle-widget]') && 
			document.querySelector('.shopify-app-block div[id*=sezzle-widget]').closest('.shopify-app-block').children.length > 4 ){		
		sezzelParent.querySelectorAll('.sezzle-shopify-info-button').forEach(function(sezzelEle){
			document.querySelector('.payment-installment-wrapper').append(sezzelEle);
		});
		sezzelParent.classList.add('hidden');
	}else{
		if( sezzelParent ){
			//const sezzelParent = document.querySelector('.shopify-app-block div[id*=sezzle-widget]').closest('.shopify-app-block');
			sezzelParent.getAttribute('data-sezzle-count') == null && (
				sezzelParent.setAttribute('data-sezzle-count', 0)	
			);
			let count = Number(sezzelParent.getAttribute('data-sezzle-count')) + 1;
			if( count < 11 ){
				setTimeout(()=>{				
					sezzelParent.setAttribute('data-sezzle-count', count)	
					sezzleCheck();
				}, 1000);			
			}
		}
	}
}




/* Play video on scroll */
function checkProductMediaVideo(){	
  const mediaItems = document.querySelectorAll('.product__media-list .product__media-item');

  if (!mediaItems.length) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      const mediaItem = entry.target;
      const hasDeferredMedia = mediaItem.querySelector('deferred-media');
			const isVisible = entry.isIntersecting;

      if (!hasDeferredMedia) return;

			console.log('entry.isIntersecting', entry.isIntersecting);

      if (isVisible) {
				if (!hasDeferredMedia.getAttribute('loaded')) {
					// window.pauseAllMedia();
					mediaItem.classList.add('show');
					hasDeferredMedia.loadContent();        
				}
				if( hasDeferredMedia.querySelector('video') ){
					hasDeferredMedia.querySelector('video').play().catch(() => {})
				}
      } else {				
				if( hasDeferredMedia.querySelector('video') ){
					hasDeferredMedia.querySelector('video').pause();
				}else{
					window.pauseAllMedia();
				}
        mediaItem.classList.remove('show');
      }
    });
  }, {
    root: null,           // 👈 Use the viewport (window scroll)
    threshold: 0.5        // Adjust as needed (50% visibility)
  });

  mediaItems.forEach(item => {
    observer.observe(item);
  });

}
/* Play video on scroll */


document.querySelectorAll('.shopify-section.pro-card-list').forEach((ele) =>{
    if( ele.querySelector('.product-card-list') == null ){
      ele.classList.add('no-image-gird')
    }
})

// Handle window resize event for responsive adjustments
window.addEventListener('resize', function () {
  // If screen size is greater than 1199px, destroy Swiper on .js-media-list if applied
  if (window.innerWidth > 1199) {
    document.querySelectorAll('.js-media-list').forEach((elem) => {
      if (elem.swiper && typeof elem.swiper.destroy === 'function') {
        elem.swiper.destroy(true, true);
        // Optionally remove swiper classes if needed
        elem.classList.remove('swiper-initialized', 'swiper-container-initialized', 'swiper-container-horizontal');
      }
    });
  }else{
	if(document.querySelectorAll('.js-media-list.swiper-initialized').length == 0){
		sliderInit(true);
	}
  }
});

